import * as React from 'react';
import {
  POINZ_ADDRESS,
  POINZ_COMPANY_NAME,
  POINZ_INFO_EMAIL,
  POINZ_PHONE,
  POINZ_ZIP,
  SWITZERLAND_COUNTRY_CODE,
  ZURICH
} from 'utils/general';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import { useTranslation } from 'next-i18next';
import Button from './Button';

const PoinzContactDetails = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mt-6 md:mt-16">
        <Heading variant="h4">{t('contact.address')}</Heading>
        <Paragraph>{POINZ_COMPANY_NAME}</Paragraph>
        <Paragraph>{POINZ_ADDRESS}</Paragraph>
        <Paragraph>{`${SWITZERLAND_COUNTRY_CODE}-${POINZ_ZIP} ${ZURICH}`}</Paragraph>
      </div>
      <div className="mt-6 md:mt-8">
        <Heading variant="h4">{t('contact.email')}</Heading>
        <Button
          variant="link"
          className="!text-neutral-900 hover:!text-neutral-700 dark:!text-neutral-50 underline !py-1 text-base"
          href={`mailto:${POINZ_INFO_EMAIL}`}
        >
          {POINZ_INFO_EMAIL}
        </Button>
      </div>
      <div className="mt-6 md:mt-8">
        <Heading variant="h4">{t('contact.phone')}</Heading>
        <Paragraph>{POINZ_PHONE}</Paragraph>
      </div>
    </>
  );
};

PoinzContactDetails.displayName = 'PoinzContactDetails';

export default PoinzContactDetails;
